import api from './api';

const adminService = {
  getStats: async () => {
    const response = await api.get('/admin/stats');
    return response.data;
  },

  // USUARIOS
  getAllUsers: async () => {
    const response = await api.get('/admin/users');
    return response.data;
  },
  updateUser: async (id, userData) => {
    const response = await api.put(`/admin/users/${id}`, userData);
    return response.data;
  },
  blockUser: async (id) => {
    const response = await api.post(`/admin/users/${id}/block`);
    return response.data;
  },
  unblockUser: async (id) => {
    const response = await api.post(`/admin/users/${id}/unblock`);
    return response.data;
  },
  resetUser: async (id) => {
    const response = await api.post(`/admin/users/${id}/reset`);
    return response.data;
  },
  deleteUser: async (id) => {
    const response = await api.delete(`/admin/users/${id}`);
    return response.data;
  },

  // OBJETOS
  getAllItems: async () => {
    const response = await api.get('/admin/items');
    return response.data;
  },
  createItem: async (itemData) => {
    const response = await api.post('/admin/items', itemData);
    return response.data;
  },
  updateItem: async (id, itemData) => {
    const response = await api.put(`/admin/items/${id}`, itemData);
    return response.data;
  },
  deleteItem: async (id) => {
    const response = await api.delete(`/admin/items/${id}`);
    return response.data;
  },
  deleteGroundItem: async (id) => {
    const response = await api.delete(`/admin/ground-items/${id}`);
    return response.data;
  },

  // ENEMIGOS
  getAllEnemies: async () => {
    const response = await api.get('/admin/enemies');
    return response.data;
  },
  createEnemy: async (enemyData) => {
    const response = await api.post('/admin/enemies', enemyData);
    return response.data;
  },
  updateEnemy: async (id, enemyData) => {
    const response = await api.put(`/admin/enemies/${id}`, enemyData);
    return response.data;
  },
  deleteEnemy: async (id) => {
    const response = await api.delete(`/admin/enemies/${id}`);
    return response.data;
  },

  // CIUDADES
  getAllCities: async () => {
    const response = await api.get('/admin/cities');
    return response.data;
  },
  getAllClans: async () => {
    const response = await api.get('/onboarding/clans');
    const clans = response.data?.clans;
    return Array.isArray(clans) ? clans : [];
  },
  createCity: async (cityData) => {
    const response = await api.post('/admin/cities', cityData);
    return response.data;
  },
  updateCity: async (id, cityData) => {
    const response = await api.put(`/admin/cities/${id}`, cityData);
    return response.data;
  },
  deleteCity: async (id) => {
    const response = await api.delete(`/admin/cities/${id}`);
    return response.data;
  },
  getAdminClans: async () => {
    const response = await api.get('/admin/clans');
    return response.data;
  },
  getAdminClanMembers: async (clanId) => {
    const response = await api.get(`/admin/clans/${clanId}/members`);
    return response.data;
  },
  setAdminClanLeader: async (clanId, leader_user_id) => {
    const response = await api.post(`/admin/clans/${clanId}/leader`, { leader_user_id });
    return response.data;
  },
  getAdminClanActivity: async (clanId) => {
    const response = await api.get(`/admin/clans/${clanId}/activity`);
    return response.data;
  },

  // MISIONES
  getAllMissions: async () => {
    const response = await api.get('/admin/missions');
    return response.data;
  },
  createMission: async (missionData) => {
    const response = await api.post('/admin/missions', missionData);
    return response.data;
  },
  updateMission: async (id, missionData) => {
    const response = await api.put(`/admin/missions/${id}`, missionData);
    return response.data;
  },
  deleteMission: async (id) => {
    const response = await api.delete(`/admin/missions/${id}`);
    return response.data;
  },

  // EVENTOS DE MISION
  getAllMissionEvents: async () => {
    const response = await api.get('/admin/mission-events');
    return response.data;
  },
  createMissionEvent: async (eventData) => {
    const response = await api.post('/admin/mission-events', eventData);
    return response.data;
  },
  updateMissionEvent: async (id, eventData) => {
    const response = await api.put(`/admin/mission-events/${id}`, eventData);
    return response.data;
  },
  deleteMissionEvent: async (id) => {
    const response = await api.delete(`/admin/mission-events/${id}`);
    return response.data;
  },

  // MAPAS/SECTORES
  getAllSectors: async () => {
    const response = await api.get('/admin/sectors');
    return response.data;
  },
  createSector: async (sectorData) => {
    const response = await api.post('/admin/sectors', sectorData);
    return response.data;
  },
  getSectorDetails: async (id) => {
    const response = await api.get(`/admin/sectors/${id}`);
    return response.data;
  },
  updateSector: async (id, sectorData) => {
    const response = await api.put(`/admin/sectors/${id}`, sectorData);
    return response.data;
  },
  deleteSector: async (id) => {
    const response = await api.delete(`/admin/sectors/${id}`);
    return response.data;
  },
  updateSectorGrid: async (id, gridData) => {
    const response = await api.put(`/admin/sectors/${id}/grid`, gridData);
    return response.data;
  },
  generateSectorWorldEntities: async (id, payload = {}) => {
    const response = await api.post(`/admin/sectors/${id}/world-entities/generate`, payload);
    return response.data;
  },

  // CONFIGURACIÓN GLOBAL
  getSettings: async () => {
    const response = await api.get('/admin/settings');
    return response.data;
  },
  updateSettings: async (settingsData) => {
    const response = await api.post('/admin/settings', settingsData);
    return response.data;
  },
  triggerCleanup: async () => {
    const response = await api.post('/admin/maintenance/cleanup');
    return response.data;
  },

  // GALERÍA DE IMÁGENES
  getGallery: async () => {
    const response = await api.get('/admin/gallery');
    return response.data;
  },
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    const response = await api.post('/admin/gallery/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },
  deleteGalleryImage: async (filename) => {
    const response = await api.delete(`/admin/gallery/${filename}`);
    return response.data;
  },

  // PORTALES
  getAllPortals: async (sectorId) => {
    const params = sectorId ? { sectorId } : {};
    const response = await api.get('/admin/portals', { params });
    return response.data;
  },
  createPortal: async (portalData) => {
    const response = await api.post('/admin/portals', portalData);
    return response.data;
  },
  deletePortal: async (id) => {
    const response = await api.delete(`/admin/portals/${id}`);
    return response.data;
  },

  // RPG INDEPENDIENTE
  getRpgTilesets: async () => {
    const response = await api.get('/admin/rpg/tilesets');
    return response.data;
  },
  createRpgTileset: async (tilesetData) => {
    const response = await api.post('/admin/rpg/tilesets', tilesetData);
    return response.data;
  },
  updateRpgTileset: async (id, tilesetData) => {
    const response = await api.put(`/admin/rpg/tilesets/${id}`, tilesetData);
    return response.data;
  },
  deleteRpgTileset: async (id) => {
    const response = await api.delete(`/admin/rpg/tilesets/${id}`);
    return response.data;
  },
  getRpgCities: async () => {
    const response = await api.get('/admin/rpg/cities');
    return response.data;
  },
  saveRpgCityConfig: async (cityId, cityData) => {
    const response = await api.put(`/admin/rpg/cities/${cityId}`, cityData);
    return response.data;
  },
  deleteRpgCityConfig: async (cityId) => {
    const response = await api.delete(`/admin/rpg/cities/${cityId}`);
    return response.data;
  },
  getRpgCityMap: async (cityId) => {
    const response = await api.get(`/admin/rpg/cities/${cityId}/map`);
    return response.data;
  },
  saveRpgCityMap: async (cityId, mapData) => {
    const response = await api.put(`/admin/rpg/cities/${cityId}/map`, mapData);
    return response.data;
  },
  getRpgNpcs: async () => {
    const response = await api.get('/admin/rpg/npcs');
    return response.data;
  },
  getRpgCropTransformations: async () => {
    const response = await api.get('/admin/rpg/crops');
    return response.data;
  },
  createRpgCropTransformation: async (cropData) => {
    const response = await api.post('/admin/rpg/crops', cropData);
    return response.data;
  },
  updateRpgCropTransformation: async (id, cropData) => {
    const response = await api.put(`/admin/rpg/crops/${id}`, cropData);
    return response.data;
  },
  deleteRpgCropTransformation: async (id) => {
    const response = await api.delete(`/admin/rpg/crops/${id}`);
    return response.data;
  },
  createRpgNpcTemplate: async (npcData) => {
    const response = await api.post('/admin/rpg/npcs/templates', npcData);
    return response.data;
  },
  updateRpgNpcTemplate: async (id, npcData) => {
    const response = await api.put(`/admin/rpg/npcs/templates/${id}`, npcData);
    return response.data;
  },
  deleteRpgNpcTemplate: async (id) => {
    const response = await api.delete(`/admin/rpg/npcs/templates/${id}`);
    return response.data;
  },
  createRpgCityNpc: async (npcData) => {
    const response = await api.post('/admin/rpg/npcs', npcData);
    return response.data;
  },
  updateRpgCityNpc: async (id, npcData) => {
    const response = await api.put(`/admin/rpg/npcs/${id}`, npcData);
    return response.data;
  },
  deleteRpgCityNpc: async (id) => {
    const response = await api.delete(`/admin/rpg/npcs/${id}`);
    return response.data;
  },
  getRpgPlayerAppearance: async () => {
    const response = await api.get('/robots/rpg-appearance');
    return response.data;
  },
  saveRpgPlayerAppearance: async (appearanceData) => {
    const response = await api.post('/robots/rpg-appearance', appearanceData);
    return response.data;
  }
};

export default adminService;
